export const resourceEnum = {
    CAR: "car",
    TRAILER: "trailer",
    DRIVER: "driver",
};

export const resourceOptions = [
    { label: "Грузовик", value: resourceEnum.CAR },
    { label: "Прицеп", value: resourceEnum.TRAILER },
    { label: "Водитель", value: resourceEnum.DRIVER },
];
